import React, { useEffect } from "react";
import "./App.css";
import "./i18n";
import LoginPageContainer from "./pages/logins/LoginPageContainer";
import { BrowserRouter, Route, Router, Routes } from "react-router-dom";
import EmailValidation from "./pages/emailValidation/EmailValidation";
import LandingPage from "./pages/landing/LandingPage";
import ProtectedRoute from "./requestHelper/ProtectedRoute";
import ErrorBoundary from "./ErrorBoundary";
import "./styles/landingPage.css";
import "./styles/loginPage.css";
import "./styles/newOrderPage.css";
import "./styles/newSample.css";
import "./styles/card.css";
import "./styles/common-components.css";
import "./styles/typography.css";
import "./styles/icons.css";
import "./styles/modal.css";
import "./styles/button.css";
import "./styles/sampleInformation.css";
import "./styles/viewSamples.css";
import "./styles/viewOrderPage.css";
import "./styles/emailValidation.css";
import "./styles/profilePage.css";
import "./styles/helpAndContactUsPage.css";
import "./styles/registerClientPortalOrderPage.css";
import "./styles/cpDetails.css";
import "./styles/organizationPage.css";
import "./styles/viewInstancePage.css";
import "./styles/viewBatchPage.css";
import "./styles/batchGenerationPage.css";
import "./styles/companyCustomStyles/ppbWorkflow.css";
import "./styles/specificationReading.css";
import "./styles/notifications.css";

import { createTheme, ThemeProvider } from "@mui/material";
import { NeutralColor, PrimaryColor } from "node-library/dist/colors";
import { SnackbarProvider } from "./common-components/toast/showToastMessage";
import ResetPassword from "./pages/emailValidation/ResetPassword";

const theme = createTheme({
	palette: {
		mode: "light",
		primary: {
			main: "#4dd7af",
			light: "#ecfdf6",
			dark: "#11B88E",
		},
		secondary: {
			main: "#382967",
			dark: "#291d49",
			light: "#efeffe",
		},
		background: {
			default: "#f3f3f5",
		},
	},
	typography: {
		fontFamily: [
			'"Lexend"',
			'"Segoe UI"',
			'"Roboto"',
			'"Oxygen"',
			'"Ubuntu"',
			'"Cantarell"',
			'"Fira Sans"',
			'"Droid Sans"',
			'"Helvetica Neue"',
			"sans-serif",
		].join(", "),
		fontSize: 16,
		h1: {
			fontSize: 57,
		},
		h2: {
			fontSize: 45,
		},
		h3: {
			fontSize: 32,
		},
		h4: {
			fontSize: 28,
		},
		h5: {
			fontSize: 24,
		},
		body1: {
			fontSize: 16,
		},
		body2: {
			fontSize: 14,
		},
		caption: {
			fontSize: 12,
		},
		button: {
			fontSize: 14,
		},
	},
	shape: {
		borderRadius: 14,
	},
	components: {
		MuiMenuItem: {
			styleOverrides: {
				root: {
					"&.Mui-selected": {
						backgroundColor: PrimaryColor.PRIMARY_200,
					},
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					padding: "10px 20px",
					borderRadius: "30px",
				},
			},
		},
		MuiCard: {
			defaultProps: {
				elevation: 0, // Remove shadow by setting elevation to 0
			},
			styleOverrides: {
				root: {
					boxShadow: "none", // Alternatively, ensure boxShadow is removed globally
				},
			},
		},
	},
});

function App() {
	return (
		<ThemeProvider theme={theme}>
			<SnackbarProvider>
				<BrowserRouter>
					<Routes>
						<Route
							path="/validate-email"
							element={<EmailValidation></EmailValidation>}
						/>
						<Route
							path="/reset-password"
							element={<ResetPassword></ResetPassword>}
						/>
						<Route path="/login" element={<LoginPageContainer />} />

						<Route
							path="/portal/:page"
							element={
								<ErrorBoundary>
									<ProtectedRoute>
										<LandingPage />
									</ProtectedRoute>
								</ErrorBoundary>
							}
						/>
						<Route
							path="/portal/:page/:elementId"
							element={
								<ErrorBoundary>
									<ProtectedRoute>
										<LandingPage />
									</ProtectedRoute>
								</ErrorBoundary>
							}
						/>

						{/* Catch-all route for 404 */}
						<Route path="*" element={<LoginPageContainer />} />
					</Routes>
				</BrowserRouter>
			</SnackbarProvider>
		</ThemeProvider>
	);
}

export default App;
